import ProtectedImg from '@/components/ProtectedImg';
import { COMMENT_TRUNCATE_LEN_SHORT, truncateString } from '@/helpers';
import { MediaCreatedMessage } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import Card, { CardProps } from './Card';
import { CardHabitatLink } from './CardLink';
import { getMediaQueryParams } from './utils';

const MediaCreatedCard = ({ messageWithMeta }: CardProps<MediaCreatedMessage>) => {
  const { message } = messageWithMeta;
  const mediaType = 'media' in message ? message.media.type : message.mediaType;
  return (
    <Card messageWithMeta={messageWithMeta}>
      {'media' in message && (
        <div className="mt-2 space-y-2">
          <CardHabitatLink
            message={message}
            query={getMediaQueryParams(message)}
            className="block"
            onClick={() => {
              trackMP('community-feed-clicked', {
                content: 'media',
              });
            }}
          >
            <ProtectedImg
              className="preflight preflight-img block aspect-video w-2/3 overflow-hidden rounded-lg mobile:w-4/5"
              src={message.media.previewURL}
              alt={message.media.title}
            />
          </CardHabitatLink>
          <p className="preflight preflight-p line-clamp-3 overflow-hidden break-words text-xs">
            &quot;
            <CardHabitatLink
              message={message}
              query={getMediaQueryParams(message)}
              onClick={() => {
                trackMP('community-feed-clicked', {
                  content: 'media-title',
                });
              }}
            >
              {truncateString(message.media.title, COMMENT_TRUNCATE_LEN_SHORT)}
            </CardHabitatLink>
            &quot; was just posted to the{' '}
            <CardHabitatLink
              message={message}
              onClick={() => {
                trackMP('community-feed-clicked', {
                  content: 'habitat',
                });
              }}
            >
              {messageWithMeta.message.habitat.title}
            </CardHabitatLink>
          </p>
        </div>
      )}
    </Card>
  );
};

export default MediaCreatedCard;
